import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ScrollToTop from "@/components/feature/ScrollToTop";
import { categories } from "@/mocks/categories";

export default function AboutPage() {
  useEffect(() => {
    document.title = "关于我们 - 妖精视频";
  }, []);

  const breadcrumbItems = [
    { label: "首页", href: "/" },
    { label: "关于我们" },
  ];

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        name: "妖精视频",
        url: "https://www.yaojingshipin.com",
        logo: "https://www.yaojingshipin.com/logo.png",
        description: "妖精视频水果植物系列，汇集香蕉视频、蜜桃视频、西瓜视频、樱花视频等热门平台，高清免费在线观看，电视剧全集不缓冲。",
        foundingDate: "2020",
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer service",
          email: "service@yaojingshipin.com",
          availableLanguage: "Chinese",
        },
      },
      {
        "@type": "WebPage",
        name: "关于我们 - 妖精视频",
        url: "https://www.yaojingshipin.com/about",
        isPartOf: { "@id": "https://www.yaojingshipin.com/#website" },
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />

      <Navbar />

      <main className="pt-16">
        <Breadcrumb items={breadcrumbItems} />

        <section className="px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-14">
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
                关于妖精视频
              </h1>
              <p className="text-sm text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                妖精视频水果植物系列成立于2020年，是一个集香蕉视频、蜜桃视频、西瓜视频、樱花视频、
                糖豆视频、樱桃视频、蘑菇视频于一体的高清影视内容聚合平台。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-vidicon-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-lg font-medium text-foreground-950 mb-2">海量资源</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  覆盖七大视频平台，汇集电视剧、电影、综艺、动漫、少儿等全品类内容，资源总量超过7000部。
                </p>
              </div>

              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-4k-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-lg font-medium text-foreground-950 mb-2">高清画质</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  支持4K超高清和1080P画质播放，采用CDN加速技术确保流畅不缓冲，为您带来极致观影体验。
                </p>
              </div>

              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-device-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="text-lg font-medium text-foreground-950 mb-2">多端同步</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  支持手机、平板、电脑全平台观看，无需下载APP，浏览器打开即看，随时随地畅享精彩内容。
                </p>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-6 text-center">
                品牌口碑
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
                <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-amber-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "妖精视频真的太方便了！一个平台就能看到各个视频网站的内容，画质还特别清晰，追剧必备神器！"
                  </p>
                  <p className="text-xs text-foreground-500">— 资深追剧达人 小雨</p>
                </div>

                <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-amber-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "一直在用妖精视频看动漫，更新速度超快，资源也很全，强烈推荐给动漫迷们！"
                  </p>
                  <p className="text-xs text-foreground-500">— 动漫爱好者 阿杰</p>
                </div>

                <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-amber-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "给孩子看动画片特别方便，蘑菇视频里的内容质量很高，寓教于乐，作为家长很放心。"
                  </p>
                  <p className="text-xs text-foreground-500">— 宝妈 小芳</p>
                </div>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                <div className="p-4 rounded-lg bg-accent-100/70 text-center">
                  <div className="text-2xl font-heading text-accent-700 mb-1">7000+</div>
                  <p className="text-xs text-accent-600">影视资源</p>
                </div>
                <div className="p-4 rounded-lg bg-primary-100/70 text-center">
                  <div className="text-2xl font-heading text-primary-700 mb-1">500万+</div>
                  <p className="text-xs text-primary-600">日活用户</p>
                </div>
                <div className="p-4 rounded-lg bg-secondary-100/70 text-center">
                  <div className="text-2xl font-heading text-secondary-700 mb-1">99.7%</div>
                  <p className="text-xs text-secondary-600">用户好评率</p>
                </div>
                <div className="p-4 rounded-lg bg-accent-100/70 text-center">
                  <div className="text-2xl font-heading text-accent-700 mb-1">7</div>
                  <p className="text-xs text-accent-600">旗下平台</p>
                </div>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-6 text-center">
                旗下平台
              </h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300 text-center transition-all cursor-pointer group"
                  >
                    <div className={`w-10 h-10 mx-auto mb-3 rounded-lg bg-gradient-to-br ${cat.color} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                      <i className={`${cat.icon} text-background-50 text-lg`}></i>
                    </div>
                    <h3 className="text-sm font-medium text-foreground-950 mb-1">{cat.name}</h3>
                    <p className="text-[10px] text-foreground-500">{cat.videoCount.toLocaleString()}+ 部</p>
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-6 text-center">
                联系我们
              </h2>
              <div className="max-w-lg mx-auto p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-mail-line text-accent-600 text-sm"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-foreground-950 mb-1">电子邮箱</h4>
                      <p className="text-sm text-foreground-600">service@yaojingshipin.com</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-customer-service-line text-primary-600 text-sm"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-foreground-950 mb-1">在线客服</h4>
                      <p className="text-sm text-foreground-600">工作日 9:00 - 18:00 在线服务</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-secondary-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-map-pin-line text-secondary-600 text-sm"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-foreground-950 mb-1">公司地址</h4>
                      <p className="text-sm text-foreground-600">北京市朝阳区建国路88号SOHO现代城A座</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}